import { render, staticRenderFns } from "./ContactPopup.vue?vue&type=template&id=05a28ed2&scoped=true&"
import script from "./ContactPopup.vue?vue&type=script&lang=js&"
export * from "./ContactPopup.vue?vue&type=script&lang=js&"
import style0 from "./ContactPopup.vue?vue&type=style&index=0&id=05a28ed2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a28ed2",
  null
  
)

export default component.exports